var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{staticStyle:{"max-height":"500px"},attrs:{"id":_vm.id,"width":"400","height":"400"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }